import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";

export const buildAnonymousHub = (anonymousConnectionUrl: string): HubConnection => {
    const connection = new HubConnectionBuilder()
        .withUrl(anonymousConnectionUrl)
        .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: () => 2000,
        })
        .build();

    return connection;
}